import { HOME_SECTION_IDS } from '@/shared/constants/homeSectionIds';

/**
 * Homepage CTA href for an action plan (non-admin notification deep link).
 *
 * @param {string|number|null|undefined} actionPlanId
 * @param {{
 *   draftActionPlanId?: string|null,
 *   implementationActionPlanId?: string|null,
 *   completedActionPlanIds?: Array<string|number>|null,
 * }} [buckets]
 * @returns {string}
 */
export function getHomeActionPlanCtaHref(
  actionPlanId,
  {
    draftActionPlanId = null,
    implementationActionPlanId = null,
    completedActionPlanIds = null,
  } = {},
) {
  if (actionPlanId == null || actionPlanId === '') {
    return '/';
  }
  const id = String(actionPlanId);
  if (draftActionPlanId != null && String(draftActionPlanId) === id) {
    return `/#${HOME_SECTION_IDS.PLANNING}`;
  }
  if (implementationActionPlanId != null && String(implementationActionPlanId) === id) {
    return `/#${HOME_SECTION_IDS.IMPLEMENTATION}`;
  }
  const completed = Array.isArray(completedActionPlanIds) ? completedActionPlanIds : [];
  if (completed.some((completedId) => completedId != null && String(completedId) === id)) {
    return `/#${HOME_SECTION_IDS.ARCHIVE}`;
  }
  return '/';
}
